module.exports = __webpack_public_path__ + "img/crypto-usdt.205475ce.svg";